export default {
  common: {
    actions: "Actions",
    add: "Add",
    apply: "Apply",
    cancel: "Cancel",
    clear: "Clear",
    confirm: "Confirm",
    create: "Create",
    delete: "Delete",
    details: "Details",
    edit: "Edit",
    export: "Export",
    filter: "Filter",
    import: "Import",
    loading: "Loading...",
    manageColumns: "Manage columns",
    noData: "No data available",
    downloadModel: "Download template file",
    save: "Save",
    search: "Search",
    settings: "Settings",
    send: "Send",
    tableName: "Table name",
    update: "Update",
    validate: "Validate",
    viewTable: "View table {table}",
    clearFilters: "Clear filters",
    all: "All",
    yes: "Yes",
    no: "No",
    na: "N/A",
    refresh: "Refresh",
    previous: "Previous",
    next: "Next",
    page: "Page",
    close: "Close",
    retour: "Back",
    loadingPrevious: "Loading previous page...",
    loadingNext: "Loading next page...",
    error: "Error",
    success: "Success",
  }
};
